"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.UnlessFeature = exports.IfFeature = exports.FeaturesContext = exports.Features = void 0;

var _react = _interopRequireDefault(require("react"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var Features = /*#__PURE__*/function () {
  function Features(enabledFeatures) {
    _classCallCheck(this, Features);

    this._enabledFeatures = new Set(enabledFeatures);
  }

  _createClass(Features, [{
    key: "testEnabled",
    value: function testEnabled(featureName) {
      return this._enabledFeatures.has(featureName);
    }
  }]);

  return Features;
}();

exports.Features = Features;

var FeaturesContext = _react["default"].createContext(new Features([]));

exports.FeaturesContext = FeaturesContext;

var IfFeature = function IfFeature(_ref) {
  var feature = _ref.feature,
      children = _ref.children;
  return /*#__PURE__*/_react["default"].createElement(FeaturesContext.Consumer, null, function (features) {
    if (features.testEnabled(feature)) {
      return children();
    } else {
      return null;
    }
  });
};

exports.IfFeature = IfFeature;

var UnlessFeature = function UnlessFeature(_ref2) {
  var feature = _ref2.feature,
      children = _ref2.children;
  return /*#__PURE__*/_react["default"].createElement(FeaturesContext.Consumer, null, function (features) {
    if (!features.testEnabled(feature)) {
      return children();
    } else {
      return null;
    }
  });
};

exports.UnlessFeature = UnlessFeature;